import DeleteIcon from "../../IconsCode/DeleteIcon";
import EditIcon from "../../IconsCode/EditIcon";
import EyeIcon from "../../IconsCode/EyeIcon";


function UsersAction({ onOpen }) {
    return (
        <div className="w-40 flex flex-row-reverse items-center justify-between">
            <EyeIcon onClick={() => onOpen("details")} />
            <EditIcon onClick={() => onOpen("edit")} />
            <DeleteIcon color="#B8AEC0" size="24" onClick={() => onOpen("delete")} />
        </div>
    );
}
export default UsersAction;